import request from "@/utils/request";


export function trialGetAllForDropdown() {
    return request({
        url: "/api/services/app/Trial/GetAllForDropDown",
        method: "GET"
    });
}

export function trialGetAll(params) {
    return request({
        url: "/api/services/app/Trial/GetAll",
        method: "GET",
        params
    });
}

export function trialGet(params) {
    return request({
        url: "/api/services/app/Trial/Get",
        method: "GET",
        params
    });
}

export function trialCreate(data) {
    return request({
        url: "/api/services/app/Trial/Create",
        method: "POST",
        data
    });
}

export function trialUpdate(data) {
    return request({
        url: "/api/services/app/Trial/Update",
        method: "PUT",
        data
    });
}

export function trialDelete(params) {
    return request({
        url: "/api/services/app/Trial/Delete",
        method: "DELETE",
        params
    });
}

export function trialClearData(data) {
    return request({
        url: "/api/services/app/Trial/ClearData",
        method: "POST",
        data
    });
}

export function trialClearCalculatedData(data) {
    return request({
        url: "/api/services/app/Trial/ClearCalculatedData",
        method: "POST",
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/trial.js